import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { login } from './loginReducer';
import { projects } from './projectsReducer';
import { user } from './userReducer';
import { loading } from './loadingReducer';
import { currentProject } from './ticketsReducer';
import { initialData } from './initReducer';
import { notifications } from './notificationsReducer';
import { criteria } from './criteriaReducer';
import { serverError } from './serverErrorReducer';
import { slips } from './slipReducer';
import { adminData } from './adminReducer';

const allReducers = combineReducers({
  routerReducer,
  projects,
  login,
  user,
  loading,
  currentProject,
  initialData,
  notifications,
  criteria,
  serverError,
  slips,
  adminData,
});

export default allReducers;
